// 用 idb 代替 storage.
import { Injectable } from '@angular/core';
//import { Drivers, Storage } from '@ionic/storage';
import { IDBPDatabase, openDB } from 'idb';

@Injectable({
  providedIn: 'root'
})
export class StorageService {
  //storage!: Storage; // | null = null;
  store: string = "my-store";
  //conf = { name: "_jkself", storeName:"_jkself2", driverOrder: [Drivers.IndexedDB, Drivers.LocalStorage] };
  private dbPromise?: Promise<IDBPDatabase>;
  constructor() { // public storage: Storage
    // this.init();

  }
  async init(app_name:string,store:string) {
    // If using, define drivers here: await this.storage.defineDriver(/*...*/);
    this.store = store;
    if (this.dbPromise === null) {
      /*try {
        this.storage = new Storage(this.conf);
        await this.storage.create();
      } catch (error: any) {
        let msg = 'StorageService.init() error:' + error.message;
        jkAlert(msg);
      }*/
      this.dbPromise =  openDB(app_name, 1, {
        upgrade(db) {
          db.createObjectStore(store);
        },
      });

    }
  }

  // Create and expose methods that users of this service can
  // call, for example:
  /*
  public async set(key: string, value: any) {
    if (!this.storage) {
      await this.init();
    }

    if (this.storage) {
      try {
        await this.storage?.set(key, value);
      } catch (error: any) {
        console.error('storage.set',error.message);
      }
    }
  }
  public async get(key: string) {
    if (!this.storage) {
      if (!this.storage) {
        await this.init();
      }
    }
    let r = null;
    try {
      let r = await this.storage?.get(key);
    } catch (error: any) {
      console.error('storage.set',error.message);
    }
    return r;
  }*/
  async setItem(key: string, value: any): Promise<void> {
    const db = await this.dbPromise;
    if(!db) return;
    const tx = db.transaction(this.store, 'readwrite');
    tx.store.put(value, key);
    await tx.done;
  }

  async getItem(key: string): Promise<any> {
    const db = await this.dbPromise;
    if(!db) return;
    return db.get(this.store, key);
  }

  async removeItem(key: string): Promise<void> {
    const db = await this.dbPromise;
    if(!db) return;
    const tx = db.transaction(this.store, 'readwrite');
    tx.store.delete(key);
    await tx.done;
  }

  async clear(): Promise<void> {
    const db = await this.dbPromise;
    if(!db) return;
    const tx = db.transaction(this.store, 'readwrite');
    tx.store.clear();
    await tx.done;
  }
}
